export default "__VITE_ASSET__CLv_BWMH__"